import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import Button from '../components/Button/Button';

function ReviewBoostSection() {
  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.3,
  });

  return (
    <div className="w-full bg-white py-20" ref={ref}>
      <div className="max-w-7xl mx-auto px-6 flex flex-col lg:flex-row items-center gap-12">
        {/* Left Content */}
        <motion.div
          initial={{ x: -100, opacity: 0 }}
          animate={inView ? { x: 0, opacity: 1 } : {}}
          transition={{ duration: 0.8, ease: 'easeOut' }}
          className="flex-1 text-center lg:text-left"
        >
          <p className="text-[#7f56d9] font-semibold text-sm mb-3">Reviews</p>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-extrabold text-gray-900 leading-tight mb-6">
            Effortlessly increase 5-star reviews
          </h2>
          <p className="text-gray-600 text-base md:text-lg mb-8 max-w-xl mx-auto lg:mx-0">
            You can collect customer reviews for your business on platforms like
            Google Reviews, Trustpilot, and Yelp to enhance credibility and attract more customers.
          </p>

          {/* Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start">
              <Button variant="primary">Get started</Button>
            <Button variant="secondary" calendly>Book a demo</Button>
          </div>
        </motion.div>

        {/* Right Image */}
        <motion.div
          initial={{ x: 100, opacity: 0 }}
          animate={inView ? { x: 0, opacity: 1 } : {}}
          transition={{ duration: 0.8, ease: 'easeOut' }}
          className="flex-1 flex justify-center relative w-full"
        >
          <div className="bg-[#f9f9fb] p-6 sm:p-8 rounded-2xl w-full max-w-[540px] h-auto aspect-[9/8] flex items-center justify-center relative overflow-hidden">
            {/* First Phone */}
            <img
              src="https://cdn.prod.website-files.com/67f50baea549023b9a732b20/67f50c8c09fe41e66573fa80_iPhone%2012%20Pro%20mockup.png"
              alt="Phone Mockup 1"
              className="w-28 sm:w-40 md:w-48 lg:w-[240px] absolute left-24 md:left-4 top-6 sm:top-10 object-cover z-10"
            />
            {/* Second Phone */}
            <img
              src="https://cdn.prod.website-files.com/67f50baea549023b9a732b20/67f50c8c09fe41e66573fa7e_iPhone%2012%20Pro%20mockup%20(1).png"
              alt="Phone Mockup 2"
              className="w-32 sm:w-44 md:w-52 lg:w-[260px] absolute right-4 sm:right-8 -bottom-6 sm:-bottom-12 object-cover"
            />
          </div>
        </motion.div>
      </div>
    </div>
  );
}

export default ReviewBoostSection;
